import { createApp, h, ref } from 'vue'

import CMHKLogout from './index.vue'

import { getI18nLangFromLandingStorage } from '@repo/common-utils/utils/landingI18nLang'
import { i18n } from './tools'

let instance = null
let app = null
const showRef = ref(false)
let closeCallback = null

const init = function (propsData = {}) {
  if (!instance) {
    // 创建一个临时容器
    const container = document.createElement('div')
    document.body.appendChild(container)

    // 保存 close 回调
    closeCallback = propsData.close

    // 使用 createApp 创建 Vue 3 应用实例
    app = createApp({
      setup() {
        return () =>
          h(CMHKLogout, {
            close: closeCallback,
            modelValue: showRef.value,
            'onUpdate:modelValue': (val) => {
              showRef.value = val
            },
          })
      },
    })

    // 使用 i18n
    if (i18n) {
      app.use(i18n)
    }

    // 挂载应用
    instance = app.mount(container)
  }
}

export const open = function (propsData = {}) {
  init(propsData)
  const lang = getI18nLangFromLandingStorage()
  if (i18n?.global) {
    i18n.global.locale = lang
  }
  showRef.value = true
}

export const hide = function () {
  showRef.value = false
}

export const close = function (duration = 300) {
  hide()

  setTimeout(() => {
    if (instance) {
      // 卸载应用并移除 DOM
      if (app) {
        app.unmount()
      }
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el)
      }
      instance = null
      app = null
      showRef.value = false
      closeCallback = null
    }
  }, duration)
}

export default {
  open,
  hide,
  close,
}
